'use client';

import { createContext, useContext } from 'react';
import type { LivingContextValue } from './types';

/**
 * Provided once by the shell (ReferenceExperience). Modules under `living/`
 * read it with `useLiving()`; rendering a module outside the shell is a bug,
 * so the hook throws instead of returning a silent default.
 */
export const LivingContext = createContext<LivingContextValue | null>(null);

export function useLiving(): LivingContextValue {
  const value = useContext(LivingContext);
  if (!value) throw new Error('useLiving() must be used inside <LivingContext.Provider>');
  return value;
}
